import { DAMAGE_CONNECTION_NEGOTIATION_REQUEST, DAMAGE_CONNECTION_NEGOTIATION_SUCCESS, DAMAGE_CONNECTION_NEGOTIATION_FAILURE, DAMAGE_CONNECTION_NEGOTIATION_DELETE_REQUEST, DAMAGE_CONNECTION_ON_RECEIVE_NOTIFICATION } from '../actions';
/**
 * Reducer for handling SignalR negotiation actions
 * @param state - Current photo capture state
 * @param action - Action containing the request/response data
 * @returns Updated state based on action type
 */
export const photoCaptureIntelligentDamageConnectionReducer = (state, action) => {
    switch (action.type) {
        case DAMAGE_CONNECTION_NEGOTIATION_REQUEST:
            return Object.assign(Object.assign({}, state), { signalRConnectionId: undefined, isSignalRConnected: false, isSignalRConnectionFailed: false });
        case DAMAGE_CONNECTION_NEGOTIATION_DELETE_REQUEST:
            return Object.assign(Object.assign({}, state), { signalRConnectionId: undefined, isSignalRConnected: false, isSignalRConnectionFailed: false });
        case DAMAGE_CONNECTION_NEGOTIATION_SUCCESS:
            return Object.assign(Object.assign({}, state), { signalRConnectionId: action.payload.connectionId, isSignalRConnected: true, isSignalRConnectionFailed: false });
        case DAMAGE_CONNECTION_NEGOTIATION_FAILURE:
            return Object.assign(Object.assign({}, state), { signalRConnectionId: undefined, isSignalRConnected: false, isSignalRConnectionFailed: true, failureMessage: action.payload.failureMessage });
        case DAMAGE_CONNECTION_ON_RECEIVE_NOTIFICATION: {
            return Object.assign(Object.assign({}, state), { signalRConnectionId: action.payload.notification.connectionId || state.signalRConnectionId, isSignalRConnected: !!(action.payload.notification.connectionId || state.signalRConnectionId), isSignalRConnectionFailed: false });
        }
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentDamageConnectionReducer.js.map